export default __webpack_public_path__ + "static/media/hero-burger-1500w.e8bd0f04.jpg";